import {Fragment, h} from 'preact';
import {getDeviceStatusLabel} from "../../tools";
import DeviceDetails from "./DeviceDetails";

export default function Device({deviceInfo, formParams}){
	return (
		<div className="device account-details__device">
			<div className="account-details__title">Прибор учета №{deviceInfo.id}
				{formParams.deviceCodes && <span className={'device-status device-status_'+deviceInfo.status}>{getDeviceStatusLabel(deviceInfo.status, formParams.deviceCodes)}</span>}
			</div>
			<div className="account-details__body">
				<DeviceDetails deviceInfo={deviceInfo}/>
			</div>
		</div>
	)
}
